import classNames from "classnames";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import type { IMenuQuery } from "@repo/shopifyV2/interface/shop";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import NewsLetterInput from "@molecules/NewsLetterInput";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

import useStoreInfo from "@queries/useStoreInfo";

import { useLayoutStore } from "@store/layout";

export default function Footer() {
  const { t } = useTranslation();

  const { openSubModal } = useLayoutStore();
  const { domain, lang } = useLanguage();
  const { isDanielJohnston } = useCheckLocation();
  const { fetchMenuData, menuData: data } = useStoreInfo();

  useEffect(() => {
    void fetchMenuData({ handle: "footer" });
  }, []);

  return (
    <footer
      className={classNames(
        "flex w-full flex-col justify-between gap-y-5 px-5 pt-50 dark:text-white",
        isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
        lang !== "ko" && "pb-5",
      )}
    >
      <section className="pc:justify-between pc:flex-row flex flex-col gap-20">
        <section className="pc:flex-row pc:gap-15 flex flex-col gap-10">
          {data?.menu.items.map((menu) => (
            <div className="pc:gap-1 flex flex-col gap-2.5" key={menu.id}>
              {menu.items.map((item) => (
                <React.Fragment key={item.id}>
                  {item.title.includes("Newsletter") ? (
                    <Button
                      as="text"
                      key={item.id}
                      onClick={() => {
                        openSubModal([{ title: "Subscribe to our Newsletter", content: <NewsLetterInput />, id: "newsletter" }]);
                      }}
                    >
                      {item.title}
                    </Button>
                  ) : (
                    <Link as="text" href={item.url?.replace(domain, "")} key={item.id}>
                      {item.title}
                    </Link>
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
        </section>
        <span className="flex items-end">{`Copyright © 2010–${new Date().getFullYear()}. All rights reserved.`}</span>
      </section>

      {lang === "ko" && (
        <div className="text-dark-grey pb-4 text-xs font-normal">
          {`${t("footer.company1")} ${t("footer.company2")} ${t("footer.company3")} ${t("footer.company4")} ${t("footer.company5")} ${t("footer.company6")}`}
        </div>
      )}
    </footer>
  );
}
